// @flow

export { default } from './TextInputWithComponent';
